export default function SeoFooter() {
  return (
    <footer className="relative z-10 bg-[#0d0a1e] py-14 text-lud-ink">
      <div className="mx-auto w-full max-w-6xl px-6">
        {/* About */}
        <section aria-labelledby="ludo-seo-about" className="mb-12">
          <h2 id="ludo-seo-about" className="font-display text-xl font-bold">
            Play Ludo Online — A Free Classic Board Game
          </h2>
          <p>
            Ludo is a free, real-time multiplayer version of the beloved classic board game,
            playable right in your browser with friends — no downloads, no accounts, just a
            6-letter room code. Each player takes a color and four tokens in the yard. Roll a
            6 to launch a token onto the 52-square track, then race your tokens around the
            board and up your home column. Up to 4 players per room makes it perfect for
            quick game nights and video calls.
          </p>
          <p>
            It is the same simple, timeless race-to-home formula: roll, move, capture and
            defend. Land on an opponent&apos;s token to send it back to the yard — unless the
            square is a safe zone. Watch out for triple sixes, and be the first player to get
            all four tokens home to win.
          </p>
        </section>

        {/* How to play */}
        <section aria-labelledby="ludo-seo-howto" className="mb-12">
          <h2 id="ludo-seo-howto">How to Play Ludo</h2>
          <ol>
            <li>Open etoo.in/ludo and type a nickname.</li>
            <li>
              Create a game room to get a 6-letter room code, and share it with your friends.
              They join with the same code from any device.
            </li>
            <li>
              On your turn, roll the dice. If you roll a 6, you can bring a token out of the
              yard onto the board — and you roll again.
            </li>
            <li>
              Tap one of the highlighted movable tokens to advance it. Then wait as the next
              player takes the spotlight.
            </li>
            <li>When all four of your tokens reach the centre square, you win.</li>
          </ol>
        </section>

        {/* Rules */}
        <section aria-labelledby="ludo-seo-rules" className="mb-12">
          <h2 id="ludo-seo-rules">Ludo Rules Explained</h2>
          <ul>
            <li>You must roll a 6 to move a token from the yard onto the board.</li>
            <li>A token must land exactly on the centre square — no overshooting.</li>
            <li>Landing on an opponent&apos;s token captures it and sends it back to their yard.</li>
            <li>Safe squares (your start square and the star squares) can never be captured.</li>
            <li>Rolling a 6 grants an extra roll, but three consecutive sixes forfeit your turn.</li>
          </ul>
        </section>

        {/* FAQ */}
        <section aria-labelledby="ludo-seo-faq">
          <h2 id="ludo-seo-faq">Frequently Asked Questions</h2>
          <div className="space-y-6">
            <article>
              <h3>Is Ludo free to play?</h3>
              <p>
                Yes. Ludo is 100% free — no downloads, no sign-ups, and no accounts. Create a
                room, share the code, and play with up to 4 friends.
              </p>
            </article>
            <article>
              <h3>How do I play Ludo online with friends?</h3>
              <p>
                Open the Ludo game page and create a room. A 6-letter room code appears —
                share it with your friends, they join from their own devices, and the host
                starts the game once everyone is ready.
              </p>
            </article>
            <article>
              <h3>How many players can play Ludo?</h3>
              <p>
                Each Ludo room supports 2 to 4 players, one color per player — Red, Green,
                Yellow, and Blue. Four players is the classic way to play.
              </p>
            </article>
            <article>
              <h3>What happens when I roll three sixes?</h3>
              <p>
                Rolling a 6 normally earns an extra roll. But three consecutive sixes in a
                row lose your turn — a classic Ludo twist to keep things fair.
              </p>
            </article>
            <article>
              <h3>Can I play Ludo on my phone?</h3>
              <p>
                Yes. Ludo works on any device with a modern browser, including iPhones, iPads,
                Android phones, and tablets. Tap a token to move it.
              </p>
            </article>
          </div>
        </section>

        {/* Internal links */}
        <nav className="mt-14 border-t border-lud-border/70 pt-8" aria-label="More about Ludo">
          <p className="text-sm font-bold text-lud-ink/70">
            More games at etoo
          </p>
          <ul className="mt-3 flex flex-wrap gap-x-6 gap-y-2 text-sm">
            <li>
              <a className="text-lud-accent-dark hover:underline" href="/pictionary/">
                Pictionary online
              </a>
            </li>
            <li>
              <a className="text-lud-accent-dark hover:underline" href="/splendour/">
                Splendour online
              </a>
            </li>
            <li>
              <a className="text-lud-accent-dark hover:underline" href="/ticket-to-train/">
                Ticket to Train online
              </a>
            </li>
            <li>
              <a className="text-lud-accent-dark hover:underline" href="/flappy-bird/">
                Flappy Bird online
              </a>
            </li>
            <li>
              <a className="text-lud-accent-dark hover:underline" href="/brick-breaker/">
                Neon Breaker online
              </a>
            </li>
          </ul>
        </nav>

        <p className="mt-10 text-center text-xs text-lud-ink/40">
          © {new Date().getFullYear()} etoo games · Ludo — free online classic board game for 2–4 players
        </p>
      </div>
    </footer>
  );
}